module.exports = __webpack_public_path__ + "img/microplastics-process-1-mobile.6a8a97cf.png";